<div class="content">
  <div *ngIf="isLoading()" class="loading">
    <mat-progress-spinner color="primary" mode="indeterminate" diameter="101">
    </mat-progress-spinner>
  </div>  
  <div class="body" *ngIf="!isLoading()">
    <div class="header">
      <div class="patient-info">
        <div class="patient-avatar" (click)="toggleTimeline($event)" [style.background-color]="getColorFromName(null, true)">
          {{getPatientInitials()}}
        </div>
        <div class="patient-identification">
          <div class="title-line" *ngIf="patient">
            <div class="page-title">{{getPatientName()}}     
              <button  (click)="onEdit()" mat-icon-button >
                <mat-icon class="edit-button">edit</mat-icon>
              </button>
            </div>
        
            <div class="patient-alerts-container">
              <div class="patient-alert" *ngFor="let alert of patient.alerts" >
                <mat-icon  svgIcon="{{getAlertIcon(alert)}}"></mat-icon>
                <div class="alert-text"><b>{{alert.text}}</b><br>
                {{getPatientAlertDate(alert)}}</div>
              </div>
            </div>
          </div>
          <div class="patient-header" *ngIf="patient">
            <div> {{cleanupIdentifier(patient)}} {{getProviderName()}} &bull; {{patient.username}} &bull; Born {{toDateOfBirthFromEpochDay(patient.dob)}} </div>
            <div><patient-tags [sourceTags]="patient.tags" [entityId]="patient.id" [context]="'PATIENT'"></patient-tags></div> 
            <div *ngIf="patient.addresses && patient.addresses.length > 0">    
 
            <b>Addresses</b>
            <span *ngFor="let address of patient.addresses"> &bull; {{getAddress(address)}}<br>
             <patient-tags [sourceTags]="patient.tags" [entityId]="address.id" [context]="'ADDRESS'"></patient-tags>  
            </span>
            </div>
            <div *ngIf="patient.phones && patient.phones.length > 0">
              <b>Phones</b><span *ngFor="let phone of patient.phones"> &bull; {{getPhone(phone)}}<br>
                <patient-tags [sourceTags]="patient.tags" [entityId]="phone.id" [context]="'PHONE'"></patient-tags>  </span>
            </div>
            <div *ngIf="patient.familyRelationships && patient.familyRelationships.length > 0"> 
                <b>Family Relationships</b><span (click)="goToFamily(fr)" *ngFor="let fr of patient.familyRelationships"> &bull; <u>{{getFamilyRelationship(fr)}}</u></span>
            </div>
           <!-- <b> : </b><span *ngFor="let phone of patient.phones">{{getPhone(phone)}}<br></span>
           Families : <span *ngFor="let fr of patient.familyRelationship">{{getFamily(fr)}}<br></span> 
            </div>    -->

          </div>
         
          <div class="scored-compasses"  *ngIf="latestScoredCompasses && latestScoredCompasses.length > 0 && (!patientEndpoints || patientEndpoints.length === 0)">
            <div class="scored-compass" (click)="showAssessment(scoredCompass.guidanceSubscriptionId, scoredCompass.lastAssessmentDay)" *ngFor="let scoredCompass of latestScoredCompasses">
              <div class="right-arrow" *ngIf="scoredCompass.lastAssessmentDay && scoredCompass.lastAssessmentDay > 0">
                <button  (click)="showAssessment(scoredCompass.guidanceSubscriptionId, scoredCompass.lastAssessmentDay)" mat-icon-button >
                  <mat-icon >chevron_right</mat-icon>
                </button>
              </div>
              <span class="compass-letters" [style.background-color]="getColorFromName(scoredCompass.compassName)">{{getLetters(scoredCompass.compassName)}}</span>
              <div class="compass-text">
                <div class="compass-title">{{scoredCompass.compassName}}</div>
                <div class="compass-sub-title">{{epochDayToDate(scoredCompass.lastAssessmentDay)}}</div>
                <div class="compass-desc" *ngIf="scoredCompass.lastAssessmentDay && scoredCompass.lastAssessmentDay > 0">
                  <div><strong>{{scoredCompass.recommendation}}</strong></div>
                </div>
                <div class="compass-desc" *ngIf="!scoredCompass.lastAssessmentDay || scoredCompass.lastAssessmentDay < 0">
                  <div><strong>(Not taken)</strong></div>
                </div>
              </div>
            </div>
          </div>
          <div class="compasses-button" *ngIf="scoredCompasses && scoredCompasses.length > 0 && (!patientEndpoints || patientEndpoints.length === 0)">
            <button  (click)="gotoCompasses()" mat-button >
              See more compasses
            </button>
          </div> 
          <div class="patient-endpoints"  *ngIf="patientEndpoints && patientEndpoints.length > 0">
            <div class="patient-endpoint-title" >
              Health Record Sources:
              </div>
            <div class="patient-endpoint-container">
              <div class="patient-endpoint" *ngFor="let patientEndpoint of patientEndpoints">
                <div class="endpoint-name">{{patientEndpoint.name}}</div>
                <div class="auth-date" *ngIf="getLastAuthDate(patientEndpoint.lastAuth)"><span class="auth-label">Last authorized:<br></span><span class="auth-value">{{getLastAuthDate(patientEndpoint.lastAuth)}}</span></div> 
                <div class="last-auth-succeeded" *ngIf="patientEndpoint.invalidGrantInd"><mat-icon>check</mat-icon></div> 
                <div class="last-auth-failed" *ngIf="!patientEndpoint.invalidGrantInd"><mat-icon>close</mat-icon></div> 
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="tabs">
      <button mat-button class="body-standard-tab" [ngClass]="{selected: tabIndex == 0}" (click)="setTab(0)">Compasses</button>
      <button mat-button class="body-standard-tab" [ngClass]="{selected: tabIndex == 1}" (click)="setTab(1)">Treatments </button>
      <div>
        <button mat-button class="body-standard-tab" [ngClass]="{selected: tabIndex == 2}" (click)="setTab(2)">Tracking Analysis</button>
      </div>
      <button mat-button class="body-standard-tab" [ngClass]="{selected: tabIndex == 3}" (click)="setTab(3)">Documents & Notes</button>
      <button mat-button class="body-standard-tab" [ngClass]="{selected: tabIndex == 4}" (click)="setTab(4)">Reminders</button>
      <div>
      <button mat-button *ngIf="shouldShowTimeline()" class="body-standard-tab" [ngClass]="{selected: tabIndex == 5}" (click)="setTab(5)">Timeline</button>
      </div>
    </div>
    <div class="compasses-container">
      <compass-tab *ngIf="tabIndex === 0" [patient]="patient" [scoredCompasses]="scoredCompasses"></compass-tab>
     </div>
    <div class="treatments-container">
     <treatments *ngIf="tabIndex === 1" [patient]="patient"></treatments>
    </div>
    <div class="results-component-container"> 
      <tracking-analysis *ngIf="tabIndex === 2" [patient]="patient" [patientResults]="results"></tracking-analysis>
    </div>
    <div class="documents-container" *ngIf="tabIndex === 3">
      <documents [contextId]="patient.id" contextType="PATIENT" [providerId]="patient.providerId"></documents>
    </div>
    <div class="reminders-container" *ngIf="tabIndex === 4">
      <reminders [patient]="patient "></reminders>
    </div>
    <div class="results-component-container">
      <timeline [scoredSubscriptions]="scoredCompasses" [patientId]="patient.id" [patientName]="getPatientName()" *ngIf="tabIndex === 5 && shouldShowTimeline() && scoredCompasses && patient" ></timeline>
    </div>
  </div>
</div>